<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi">For Isaac and Bryson. If words are weapons, you’re the reason I fight.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?b8984906